import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import q from '../../../client_customizations/assets/images/icons/icon-tooltip.svg';
import { useIntl } from 'react-intl';

const ToolTip = ({ id, message }) => {
  const intl = useIntl();
  const isRtl =
    typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
  const hasMessageKey =
    intl &&
    intl.messages &&
    Object.prototype.hasOwnProperty.call(intl.messages, id);

  let content = message;
  if (typeof message === 'string' && hasMessageKey) {
    content = intl.formatMessage({ id, defaultMessage: message });
  }

  return (
    <>
      <span id={id} style={{ display: 'inline-block' }}>
        <img
          src={q}
          alt=""
          style={{
            width: '16px',
            marginInlineStart: '5px',
            marginBottom: '3px',
          }}
        />
      </span>
      <UncontrolledTooltip
        placement={isRtl ? 'left' : 'right'}
        target={id}
        transition={{ timeout: 0 }}
      >
        <span>{content}</span>
      </UncontrolledTooltip>
    </>
  );
};

export default ToolTip;

ToolTip.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
};
